import esLocale from 'element-ui/lib/locale/lang/es' //引入element语言包
const es = {
  posterPage: {
    title1:'¡¡ la función de suscripción está a punto de lanzarse!',
    title2:'¡¡ renovación de suscripción, actualización de privilegios!',
    title3:'Descuentos exclusivos y renovaciones más rentables',
    title4:'Para obtener el Código de cambio, puede consultar al vendedor que compró el equipo.',
    title5:'Función de experiencia prioritaria',
    function1:'Detalles de la función:',
    function2:'Renovación de servicios básicos (traducción simultánea, asistente de conferencias, asistente inteligente)...',
    function3:'Suscripción de servicio de valor agregado (traducción fuera de línea, traducción de llamadas de audio y video)...',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Código de cambio',
    ValueAddedServices: 'Servicios de valor agregado',
    UpgradedExperience: 'Derechos exclusivos de valor agregado, actualización de la experiencia',
    OfflineTranslation: 'Traducción fuera de línea',
    NoInternet: 'No es necesario conectarse a Internet · traducción instantánea · segura y confiable',
    GoToSubscribe: 'Ir a suscribirse',
    AudioAndVideoCall: 'Llamadas de audio / video',
    RealTimeCall: 'Traducción de voz en tiempo real · comunicación sin barreras',
    BaseService: 'Servicios básicos',
    AIAssistant: 'Función: traducción simultánea · asistente de conferencias · asistente de Ia',
    LanguagesSetting:'Configuración del idioma',
    languages1:'Chino simplificado',
    languages2:'Chino tradicional',
    languages3:'Inglés',
    languages4:'Japonés',
    languages5:'Coreano',
    languages6:'Ruso',
    languages7:'Español',
    languages8:'Francés',
    languages9:'Alemán',
    languages10:'Portugués',
    languages11:'Italiano',
    languages12:'Turco',
    languages13:'Vietnamita',
    languages14:'Indonesio',
    languages15:'Hindi',
    languages16:'árabe',
    languages17:'Tailandés',
    languages18:'Persa',
  },
  Login: {
    ToLogin: 'Iniciar sesión',
    PhoneLogin: 'Número de teléfono móvil para iniciar sesión',
    EmailLogin: 'Inicio de sesión del buzón',
    PhonePlaceholder: 'Por favor, introduzca el número de teléfono móvil',
    EmailPlaceholder: 'Enter email',
    Code: 'Código de verificación',
    and: 'Y',
    BeforeText: 'Crear una cuenta al mismo tiempo significa que estás de acuerdo y cumples',
    UserAgreement: 'Protocolo de usuario',
    privacy: 'Política de privacidad',
    errorMessage: 'Error en el Código de verificación',
    readTitle: 'Leer y aceptar los siguientes acuerdos',
    readBefore: 'Para garantizar la seguridad de su información personal, lea y acepte primero',
    cancel: 'Cancelación',
    agree: 'Acordar y continuar',
    error1:'Introduzca una dirección de correo electrónico válida',
    error2:'Introduzca el número de teléfono correcto',
    error3:'Por favor, introduzca el Código de verificación',
    success:'Inicio de sesión exitoso'
  },
  OffLinePage: {
    title: 'Traducción fuera de línea',
    NoInternet: 'No es necesario conectarse a Internet · traducción instantánea · segura y confiable',
    ServiceLife: 'Período de uso',
    forever: 'Uso permanente',
    describe: 'Instrucciones de suscripción',
    describeItem1: '1.La función de traducción fuera de línea es de pago único, uso permanente, permisos de uso para seguir el dispositivo bluetooth, si se cambia el dispositivo, es necesario volver a suscribirse al Código de cambio de traducción fuera de línea.',
    describeItem2: '2.No se puede reembolsar después de suscribirse al Código de autorización.',
    describeItem3: '3. se admiten 10 idiomas: chino, inglés, alemán, japonés, coreano, indio, tailandés, español, francés y ruso.',
    quantity: 'Cantidad',
    payType: 'Método de pago',
    card: 'Tarjeta bancaria',
    wx: 'Wechat',
    GooglePay: 'Google Pay',
    subscribe: 'Suscripción',
    RMB: '¥',
    confirm:'Confirmación',
    cardNumber:'Número de tarjeta',
    periodOfValidity:'Período de validez',
    safetyCode:'Código de Seguridad',
    name:'Nombre',
    yearAndMonth:'Año / mes',
    message1:'La cantidad no puede ser 0',
    popTip:'Consejos cálidos',
    popText1:'Por favor, lea y entienda cuidadosamente.',
    popText2:'Protocolo de pago de traducción fuera de línea',
    popText3:'He leído y estoy de acuerdo',
    popText4:'Leído y acordado',
  },
  AudioVideoPage: {
    title: 'Llamadas de audio / video',
    RealTime: 'Traducción de voz en tiempo real · comunicación sin barreras',
    describe: 'Instrucciones de suscripción',
    describeItem1: '1.La función de traducción de llamadas de audio y video es recargar el número de minutos de compra, el número de minutos se calcula a partir de la conexión de la llamada, los permisos siguen la cuenta, si se inicia sesión en otras cuentas, es necesario recargar.',
    describeItem2: '2.Después de recargar la cuenta, se pueden conectar y vincular diferentes dispositivos como de costumbre.',
    describeItem3: '3.La función de traducción de llamadas de audio y video no se puede reembolsar después de la recarga.',
    payType: 'Método de pago',
    card: 'Tarjeta bancaria',
    wx: 'Wechat',
    GooglePay: 'Google Pay',
    subscribe: 'Suscripción',
    RMB: '¥',
    sale: 'Descuentos',
    confirm:'Confirmación',
    time1:'Segundos',
    time2:'Min',
    time3:'Horas',
    time4:'Días',
    time5:'Mes',
    time6:'Año',
  },
  OffLineResult: {
    title1: 'Traducción fuera de línea',
    title2: 'Llamadas de audio / video',
    title3: 'Servicios básicos',
    success: 'La suscripción fue exitosa',
    fail: 'Falló la suscripción',
    stock:'Código de cambio en stock',
    saveTitle: 'Guarde el Código de cambio y vaya a la aplicación para cambiarlo.',
    code: 'Código de cambio',
    tip1: 'Este Código solo se utiliza para cambiar la función de traducción fuera de línea.',
    tip2: 'Este Código solo se utiliza para la función de traducción de voz / videollamada',
    tip3: 'Este Código solo se utiliza para cambiar la función de renovación del servicio básico.',
    save: 'Guardar',
    time: 'Tiempo de suscripción:',
    copy: 'Copiar',
    copySuccess: 'Copia exitosa',
    loading:'En carga',
    paySuccess:'Pago exitoso'
  },
  RedemptionList: {
    title: 'Mi Código de cambio',
    view: 'Ver',
    time: 'Tiempo de suscripción:',
  },
  MyRedemption: {
    title: 'Mi Código de cambio',
    code: 'Código de cambio',
    time: 'Tiempo de suscripción:',
    copy: 'Copiar',
    tip1: 'Este Código solo se utiliza para cambiar la función de traducción fuera de línea.',
    tip2: 'Este Código solo se utiliza para la función de traducción de voz / videollamada',
    tip3: 'Este Código solo se utiliza para cambiar la función de renovación del servicio básico.',
    save: 'Guardar',
    success:"Operación exitosa"
  },
  basePage:{
    error1:'No se obtuvo información sobre el producto',
    message1:'Por favor, elija el producto',
    title:'Servicios básicos',
    function:'Función: traducción simultánea · asistente de conferencias · asistente de Ia',
    describe: 'Instrucciones de suscripción',
    describe1:'1.Después de la renovación de los servicios básicos, como traductores simultáneos y asistentes de conferencias, el período de validez sigue al equipo, y si se cambia el equipo, se necesita una nueva renovación.',
    describe2:'2.Los servicios básicos no se pueden reembolsar después de la renovación.',
    payType: 'Método de pago',
    card: 'Tarjeta bancaria',
    wx: 'Wechat',
    GooglePay: 'Google Pay',
    subscribe: 'Suscripción',
    RMB: '¥',
    sale: 'Descuentos',
    month:'Mes',
    confirm:'Confirmación',
    month1:'1 mes',
    month2:'Medio año',
    month3:'1 año'
  },
  ...esLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default es;
